module.exports = __webpack_public_path__ + "img/inner_3_bg.311a8775.png";